import React from 'react';

const SecurePaymentsComponent = () => {
    return (
        <section className="as_about_wrapper as_padderTop80 as_padderBottom80">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12">
                        <h1 className="as_heading text-center">Secure Payments</h1>
                        <div className="as_font14 as_padderTop20" style={{lineHeight: '1.8'}}>
                            <p><b>Your financial security is extremely important to us.</b></p>
                            <h2>Safe Transactions</h2>
                            <p>Astroscope uses industry-leading encryption technology and trusted payment gateways to ensure that all your transactions are safe and secure.</p>
                            <h2>No Storage of Sensitive Data</h2>
                            <p>We do not store your credit card, debit card, or banking details on our servers. All payment information is processed directly by our secure payment partners.</p>
                            <h2>Multiple Payment Options</h2>
                            <p>Your payment security is important to us. Astroscope uses industry-standard encryption and trusted payment gateways to ensure all transactions are safe and secure. We do not store your card or banking details on our servers. Shop and consult with confidence, knowing your financial information is protected.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SecurePaymentsComponent; 